import path from 'node:path';
import { randomUUID } from 'node:crypto';
import { toJsonString } from '@wix/cli-fs';
import { componentGenerator } from '@wix/gena';
import type { SupportedServicePlugin } from '@wix/cli-app-definitions';
import { getServicePluginsFolder } from '@wix/cli-app-definitions';
import { match } from 'variant';
import { ServicePluginTypeToFolderName } from '../../../dev-center/components/backend/config.js';

// NOTE: path is relative to the build folder
const SERVICE_PLUGIN_TEMPLATE = path.resolve(
  __dirname,
  '../templates/service-plugin'
);

export async function generateServicePlugin(
  projectFolder: string,
  servicePluginType: SupportedServicePlugin,
  name: string
) {
  const servicePluginTypeLower =
    ServicePluginTypeToFolderName(servicePluginType);

  const cwd = path.join(
    getServicePluginsFolder(projectFolder),
    servicePluginTypeLower,
    name
  );

  const servicePluginConfigBase = {
    $schema: `https://dev.wix.com/wix-cli/schemas/${servicePluginTypeLower}.json`,
    id: randomUUID(),
    name,
  };

  const servicePluginConfig = match(servicePluginType, {
    ECOM_ADDITIONAL_FEES: () => ({}),
    ECOM_SHIPPING_RATES: () => ({
      name: 'Shipping Rates Provider',
      description: 'Short description about this shipping provider',
      fallbackDefinitionMandatory: false,
    }),
    ECOM_DISCOUNTS_TRIGGER: () => ({}),
    ECOM_VALIDATIONS: () => ({
      validateInCart: false,
    }),
    ECOM_PAYMENT_SETTINGS: () => ({
      fallbackValueForRequires3dSecure: false,
    }),
    ECOM_RECOMMENDATIONS_PROVIDER: () => ({}),
    EXTERNAL_DATABASE_PROVIDER: () => ({}),
    SEO_KEYWORDS_SUGGESTIONS: () => ({}),
    PREMIUM_CUSTOM_CHARGES: () => ({}),
    GIFT_CARDS_PROVIDER: () => ({}),
    BOOKINGS_PRICING_PROVIDER: () => ({}),
    STAFF_SORTING_PROVIDER: () => ({}),
  });

  const servicePluginConfigJSON = toJsonString(
    { ...servicePluginConfigBase, ...servicePluginConfig },
    {
      spaces: 2,
    }
  );

  return await componentGenerator({
    template: path.join(SERVICE_PLUGIN_TEMPLATE, servicePluginTypeLower),
    projectFolder,
    cwd,
    data: {
      servicePluginConfigJSON,
    },
  });
}
